"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHooks = void 0;
const browser_core_1 = require("@datadog/browser-core");
exports.createHooks = (browser_core_1.abstractHooks);
//# sourceMappingURL=hooks.js.map